import { DEFAULT_BINGO_SETTINGS, DEFAULT_BINGO_WIN } from "./types.js";
export const BINGO_PRESETS = {
    easy: ["DECADE", "YEAR_PM4", "BEFORE_2000", "SOLO_GROUP"],
    normal: ["DECADE", "YEAR_PM2", "YEAR_PM4", "SOLO_GROUP"],
    expert: ["YEAR_EXACT", "ARTIST", "TITLE", "DECADE"],
};
export function settingsFromPreset(preset, patch) {
    const categories = preset === "custom"
        ? (patch?.categories ?? DEFAULT_BINGO_SETTINGS.categories)
        : BINGO_PRESETS[preset];
    return {
        ...DEFAULT_BINGO_SETTINGS,
        ...patch,
        preset,
        categories: [...categories],
        winConditions: { ...DEFAULT_BINGO_WIN, ...patch?.winConditions },
    };
}
